/**
 * @description The data class for the diagram. Holds the initialization data.
 */
export const StandardData = function () {
    const instance = {};
    class StandardData {
        data;

        publicInitData;

        instanceUuid;

        constructor(diagramInstanceUuid) {
            if (!instance[diagramInstanceUuid]) {
                // setting the singleton instance
                instance[diagramInstanceUuid] = this;
                this.instanceUuid = diagramInstanceUuid;
            }
            return instance[diagramInstanceUuid];
        }

        init(data) {
            this.data = data;
        }

        destroy(instanceUuid) {
            instance[instanceUuid] = null;
            delete instance[instanceUuid];
        }
    }
    return StandardData;
};
